var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6D1350D2-CDB4-4A43-962D-F8EB7E8AC37C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-111.000000, -374.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List",
    transform: "translate(111.000000, 374.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Title",
    stroke: "none",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 5,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19,
    y: 6,
    fill: "#000000"
  }, "Title")), /*#__PURE__*/React.createElement("text", {
    id: "Title-Copy",
    stroke: "none",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 5,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19,
    y: 26,
    fill: "#000000"
  }, "Title")), /*#__PURE__*/React.createElement("text", {
    id: "Title-Copy-2",
    stroke: "none",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 5,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19,
    y: 46,
    fill: "#000000"
  }, "Title")), /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum-dolor-si",
    stroke: "none",
    fill: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19,
    y: 12,
    fill: "#6F6F6F"
  }, "Lorem ipsum dolor sit amet.")), /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum-dolor-si-Copy",
    stroke: "none",
    fill: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19,
    y: 32,
    fill: "#6F6F6F"
  }, "Lorem ipsum dolor sit amet.")), /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum-dolor-si-Copy-2",
    stroke: "none",
    fill: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19,
    y: 51,
    fill: "#6F6F6F"
  }, "Lorem ipsum dolor sit amet.")), /*#__PURE__*/React.createElement("polyline", {
    id: "Line-3",
    stroke: "#909090",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "square",
    points: "104 44 106 46 104 48"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Line-3-Copy-2",
    stroke: "#909090",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "square",
    points: "104 25 106 27 104 29"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Line-3-Copy-3",
    stroke: "#909090",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "square",
    points: "104 5 106 7 104 9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.474576271,
    y1: 16.5,
    x2: 111.525424,
    y2: 16.5,
    id: "Line-4",
    stroke: "#BBBBBD",
    strokeWidth: 0.3,
    fill: "none",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.474576271,
    y1: 36.5,
    x2: 111.525424,
    y2: 36.5,
    id: "Line-4-Copy-4",
    stroke: "#BBBBBD",
    strokeWidth: 0.3,
    fill: "none",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.474576271,
    y1: 55.5,
    x2: 111.525424,
    y2: 55.5,
    id: "Line-4-Copy-5",
    stroke: "#BBBBBD",
    strokeWidth: 0.3,
    fill: "none",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "none",
    fill: "#D8D8D8",
    fillRule: "evenodd",
    cx: 8,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    stroke: "none",
    fill: "#D8D8D8",
    fillRule: "evenodd",
    cx: 8,
    cy: 26,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    stroke: "none",
    fill: "#D8D8D8",
    fillRule: "evenodd",
    cx: 8,
    cy: 46,
    r: 7
  }), /*#__PURE__*/React.createElement("text", {
    id: "B",
    stroke: "none",
    fill: "none",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 6,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 9,
    fill: "#000000"
  }, "B")), /*#__PURE__*/React.createElement("text", {
    id: "B-Copy",
    stroke: "none",
    fill: "none",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 6,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 28,
    fill: "#000000"
  }, "B")), /*#__PURE__*/React.createElement("text", {
    id: "B-Copy-2",
    stroke: "none",
    fill: "none",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 6,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 48,
    fill: "#000000"
  }, "B")))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.4dc97e9cf3e379bbcb25baea31d9eeb6.svg";
export { ForwardRef as ReactComponent };